// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    key: z.string().min(1).max(256),
    value: jsonObjectGuard.optional(),
});
const guard = z.object({
    key: z.string().max(256),
    value: jsonObjectGuard,
});
export const Systems = Object.freeze({
    table: 'systems',
    tableSingular: 'system',
    fields: {
        key: 'key',
        value: 'value',
    },
    fieldKeys: [
        'key',
        'value',
    ],
    createGuard,
    guard,
});
